<h1 mat-dialog-title *ngIf="false">הזן ת.ז\דרכון</h1>
<div mat-dialog-content>
  <mat-error *ngIf="error" class="alert alert-danger mt-1">{{ error }}</mat-error>
  <p>{{ 'MSG.REQUIRED-ID-FOR-APPOINTMENT' | translate }}</p>

  <!--cancel reason available only for canceling appointment-->
  <div class="mt-2" fxLayout="row">

    <mat-form-field style="width: 70px;" class="m-1">
      <select matNativeControl required [(ngModel)]="data.idType" class="mat-select">
        <option value="1">{{'COMMON.TZ' | translate}}</option>
        <option value="2">{{'COMMON.Passport' | translate}}</option>
      </select>
    </mat-form-field>

    <mat-form-field style="width: 140px;" class="m-1">
      <input matInput  [(ngModel)]="data.idNumber" maxlength="12" autocomplete="off"  appNumbersOnly my-color/>    
    </mat-form-field>

  </div>

</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">{{'COMMON.CANCEL' | translate}}</button>
  <button mat-button cdkFocusInitial [disabled]="!isValid()" (click)="onOK()" >{{'COMMON.OK' | translate}}</button>
</div>